import { makeStyles } from '@mui/styles';
import colors from "../../../../../common/styles/colors";

export const useLanguageSwitchStyle = makeStyles({
  headerContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    marginLeft: '10px',
    color: colors.primary
  },
  summaryTitle: {
    textTransform: 'uppercase',
    color: colors.greenColor2,
    fontWeight: 500,
    fontSize: 12,
    marginLeft: '-3px'
  }
});
